export enum EnrollmentStatusCode {
    CREATED = 'CREATED',
    STARTED =  'STARTED',
    PHONE_REGISTERED = 'PHONE_REGISTERED',
    PHONE_VALIDATED = 'PHONE_VALIDATED',
    PASSWORD_REGISTERED = 'PASSWORD_REGISTERED',
    EXPIRED = 'EXPIRED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
    FINISHED = 'FINISHED',
    PENDING = 'PENDING',
    UNKNOWN = 'UNKNOWN'
}

export function enrollmentStatusCodeOf(value: string): EnrollmentStatusCode {
    switch (value) {
        case 'CREATED':
            return EnrollmentStatusCode.CREATED;

        case 'STARTED':
            return EnrollmentStatusCode.STARTED;

        case 'PHONE_REGISTERED':
            return EnrollmentStatusCode.PHONE_REGISTERED;

        case 'PHONE_VALIDATED':
            return EnrollmentStatusCode.PHONE_VALIDATED;

        case 'PASSWORD_REGISTERED':
            return EnrollmentStatusCode.PASSWORD_REGISTERED;

        case 'EXPIRED':
            return EnrollmentStatusCode.EXPIRED;

        case 'REJECTED':
            return EnrollmentStatusCode.REJECTED;

        case 'CANCELLED':
            return EnrollmentStatusCode.CANCELLED;

        case 'FINISHED':
            return EnrollmentStatusCode.FINISHED;

        case 'PENDING':
            return EnrollmentStatusCode.PENDING;

        default:
            return EnrollmentStatusCode.UNKNOWN;
    }
}

export function valueOfEnrollmentStatusCode(value: EnrollmentStatusCode): string {
    return value;
}